<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <b-row class="align-items-start">

      <b-col md="3" v-for="(input, key) in fields" :key="key">
        <label :for="input.name">{{input.label}}
          <span v-if="input.required" class="text-danger">{{$t('form.required_star')}}</span>
        </label>

        <div v-if="input.type === 'switch'"
             class="d-flex flex-row mb-4 input-height align-items-center">

        <span class="pr-2"
              :class="[input.title && params[input.name] ? 'disabled' : '']">
          {{input.titleFalse}}
        </span>

          <label class="switch switch-3d switch-success mb-0">
            <b-form-checkbox type="checkbox"
                             class="switch-input"
                             v-model="params[input.name]"
            />
            <input type="checkbox"
                   class="switch-input"
                   :checked="params[input.name]"
            >
            <span class="switch-slider"></span>
          </label>
          <span class="pl-2" :class="[input.title && !params[input.name] ? 'disabled' : '']">{{input.title}}</span>
        </div>


        <textarea
          v-else-if="input.type === 'textarea'"
          class="rounded w-100 mb-4"
          rows="3"
          v-model="params[input.name]"
        ></textarea>

        <div v-else
             class="mb-4">
          <b-form-input
            v-model="params[input.name]"
            :type="input.type"
            :required="input.required"
            :placeholder="input.placeholder"
            :name="input.name"
            :id="input.name"
            :min="input.min"
          />

          <div class="invalid-feedback position-absolute mt-0 text-left">
            {{$t('errors.error_validation')}}
          </div>

        </div>
      </b-col>

      <b-col :md="columnWith" v-if="editing && params.invites && params.invites.length > 0">

        <div class="mb-4">

          <label>{{$t('invite.invite_url')}}</label>

          <inputCopyValue
            v-for="(invite, index) in params.invites"
            :key="index"
            :value="invite.url"
            :id="invite.uid"
            :tooltip="$t('invite.invite_copied')"
            :class="index !== params.invites.length -1 ? 'mb-3' : ''"
          />

        </div>

      </b-col>

    </b-row>

  </div>
</template>

<script>
  import inputCopyValue from '../../components/global/inputCopyValue.vue'

  export default {
    name: 'PartnerView',
    middleware: 'auth',
    components: {inputCopyValue},
    props: {
      fields: {
        type: Array,
        require: true
      },
      columnWith: {
        type: Number,
        default: 4
      },
      prefillParams: {
        type: Object,
        default: () => {}
      },
      submit: {
        type: Boolean
      },
      editing: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        params: {
          title: '',
          description: '',
          active: true,
          resources_limit: "1",
          settings: {}
        },
      }
    },
    mounted() {
      if (this.editing) {
        this.params = this.prefillParams;
      }
    },
    methods: {},
    watch: {
      submit() {
        this.params.settings.resources_limit = this.params.resources_limit;
        this.$emit('submit', this.params)
      }
    }
  }
</script>
